import App from './App.vue';
import {createApp} from 'vue';
import {vfmPlugin} from 'vue-final-modal';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import events from 'events';

export function initAffiliateMap() {
    const root = document.getElementById('affiliateMap');
    if (root) {
        initMap(root);
    }
}

/**
 * @param {HTMLElement} root
 */
function initMap(root) {
    const dataEl = root.querySelector('#affiliateMap-data');

    // Extract props from CDATA
    const props = JSON.parse(dataEl.innerText || '{}');
    const strings = props?.strings || {};
    const api = props?.api || { rest_url: '/wp-json' };
    const googleApiKey = props.googleMaps?.api_key;
    const data = props?.data;

    if (process.env.MIX_WP_ENV === 'development') {

        console.group('Affiliate map');

        console.log('Types enum', props.typesEnum);
        console.log('Strings', strings);
        console.log('Api', api);
        console.log('Google Maps', props.googleMaps);

        if (data) {
            console.groupCollapsed(`Affiliates (${data.affiliates.length})`);
            data.affiliates.forEach(v => console.log(v));
            console.groupEnd();
        } else {
            console.warn(`Missing required "data" object!`);
        }

        console.groupEnd();
    }

    const app = createApp(App, data || {});

    app.use(vfmPlugin);
    app.use(VueGoogleMaps, {
        load: {
            key: googleApiKey,
            // IMPORTANT to include geometry library which is used for distance calculations
            libraries: 'geometry,places',
        },
    });

    app.use({
        install(theApp, ...opts) {

            theApp.config.globalProperties.$events = new events.EventEmitter();

            theApp.config.globalProperties.$rawProps = props;
            theApp.config.globalProperties.$affiliateTypes = Object.assign({}, props.typesEnum) || {};
            for (let key of Object.keys(props.typesEnum)) {
                theApp.config.globalProperties.$affiliateTypes[props.typesEnum[key]] = key;
            }
            theApp.config.globalProperties.$isDealer = (affiliate) => affiliate.types.includes(props.typesEnum.dealer);
            theApp.config.globalProperties.$isService = (affiliate) => affiliate.types.includes(props.typesEnum.service);

            /**
             * @param {string} path
             * @returns {string}
             */
            theApp.config.globalProperties.$str = function cmStrTranslate(path){
                let o = strings;
                let backup = [];
                const pathArr = path.split('.');
                for (let f of pathArr) {
                    if (typeof o[f] === 'string') {
                        return o[f];
                    } else if (o[f] && typeof o[f] === 'object') {
                        o = o[f];
                    }
                    backup.push(f);
                }
                return backup.join('.');
            };


            const restUrl = api.rest_url.endsWith('/')
                            ? api.rest_url.substring(0, api.rest_url.length - 1)
                            : api.rest_url;

            /**
             * @param {string} endpoint
             * @param {RequestInit} args
             * @returns {Promise<Response>}
             */
            theApp.config.globalProperties.$fetch = async function cmFetch(endpoint = '', args = {}) {
                const opts = Object.assign({}, {
                    headers: Object.assign({}, {
                        'Content-Type': 'application/json',
                        'Accept-Content-Type': 'application/json',
                    }, args.headers || {}),
                }, args);
                const path = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
                return fetch(`${restUrl}/brokk/v1/${path}`, opts);
            };
        },
    });
    app.mount(root);
}
